import { TASKS } from "constants/actions";
import DiagnoseOperationInput from "./_variants/DiagnoseOperationInput";
import FertilizeOperationInput from "./_variants/FertilizeOperationInput";
import DrugOperationInput from "./_variants/DrugOperationInput";
import OtherOperationInput from "./_variants/OtherOperationInput";
import WateringOperationInput from "./_variants/WateringOperationInput";
import { useFormikContext } from "formik";
import { useActionChoices } from "stores";

/**
 *
 * @param {Object} props
 * @param {string} [props.placeholder] - The placeholder text for the select input.
 * @param {string} [props.helperText] - The helper text for the select input.
 * @param {boolean} props.isProposed - Indicates whether the value is for a proposed action, affecting the input name construction.
 * @param {boolean} props.isViewMode - Determines if the input should be rendered in view mode, which typically disables editing and may change the appearance.
 * @param {boolean} props.isDisabled - A flag to disable the select input, preventing user interaction when true.
 * @returns {JSX.Element} A FormSelectInput component configured for selecting an operation type, with appropriate props for Formik integration and conditional behavior based on the provided flags.
 */
const OperationInput = ({
  placeholder,
  helperText,
  isProposed,
  isViewMode,
  isDisabled,
}) => {
  const { getActionById } = useActionChoices();
  const { values } = useFormikContext();
  const taskId = values.taskId;
  const task = getActionById(taskId);
  switch (task) {
    case TASKS.diagnose:
      return (
        <DiagnoseOperationInput
          placeholder={placeholder}
          helperText={helperText}
          isProposed={isProposed}
          isViewMode={isViewMode}
          isDisabled={isDisabled}
        />
      );
    case TASKS.fertilize:
      return (
        <FertilizeOperationInput
          placeholder={placeholder}
          helperText={helperText}
          isProposed={isProposed}
          isViewMode={isViewMode}
          isDisabled={isDisabled}
        />
      );
    case TASKS.drug:
      return (
        <DrugOperationInput
          placeholder={placeholder}
          helperText={helperText}
          isProposed={isProposed}
          isViewMode={isViewMode}
          isDisabled={isDisabled}
        />
      );
    case TASKS.other:
      return (
        <OtherOperationInput
          placeholder={placeholder}
          helperText={helperText}
          isProposed={isProposed}
          isViewMode={isViewMode}
          isDisabled={isDisabled}
        />
      );
    case TASKS.watering:
      return (
        <WateringOperationInput
          placeholder={placeholder}
          helperText={helperText}
          isProposed={isProposed}
          isViewMode={isViewMode}
          isDisabled={isDisabled}
        />
      );
    default:
      return null;
  }
};

export default OperationInput;
